<template>
  <el-dialog
    :title="settleDialogTitle"
    append-to-body
    :visible="settleDialogVisible"
    :close-on-click-modal="false"
    width="80%"
    @close="closeDialog"
  >
    <vxe-table
      border
      show-overflow
      resizable
      size="mini"
      align="center"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      :auto-resize="true"
      :data="dialogData"
    >
      <vxe-table-column type="index" width="60" title="序号"></vxe-table-column>
      <!-- <vxe-table-column v-if="dialogType === 'order'" field="orderCode" title="订单编号">
      </vxe-table-column> -->
      <!-- <vxe-table-column field="userName" title="指令单"> </vxe-table-column> -->
      <vxe-table-column field="instructionNo" title="指令单编号"> </vxe-table-column>
      <vxe-table-column field="settlementStatusName" title="结算单状态"> </vxe-table-column>
      <vxe-table-column field="settlementIssueStatusName" title="开票状态"> </vxe-table-column>
      <vxe-table-column field="paymentStatusName" title="付款状态"> </vxe-table-column>
      <vxe-table-column field="receiveStatusName" title="收款状态"> </vxe-table-column>
    </vxe-table>
    <div slot="footer">
      <el-button @click="closeDialog">返回</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import XEUtils from 'xe-utils';
  export default {
    name: 'settleDialog',
    props: ['settleDialogTitle', 'settleDialogVisible', 'dialogData', 'dialogType'],
    data() {
      return {
        // tableData: [],
        settlementStatusList: [
          {
            label: '保存',
            value: '01',
          },
          {
            label: '审批中',
            value: '02',
          },
          {
            label: '已驳回',
            value: '03',
          },
          {
            label: '已通过',
            value: '04',
          },
          {
            label: '已撤回',
            value: '05',
          },
          {
            label: '已锁定',
            value: '06',
          },
          {
            label: '已关闭',
            value: '07',
          },
        ],
        settlementIssueStatusList: [
          {
            label: '已开票',
            value: '01',
          },
          {
            label: '未开票',
            value: '02',
          },
          {
            label: '部分开票',
            value: '03',
          },
        ],
        receiveStatusList: [
          {
            label: '已收款',
            value: '01',
          },
          {
            label: '未收款',
            value: '02',
          },
          {
            label: '部分收款',
            value: '03',
          },
        ],
        paymentStatusList: [
          {
            label: '已付款',
            value: '01',
          },
          {
            label: '未付款',
            value: '02',
          },
          {
            label: '部分付款',
            value: '03',
          },
        ],
      };
    },
    created() {
      this.dealTableData();
    },
    methods: {
      dealTableData() {
        console.log(this.dialogData, 'dialogData');
        if (this.dialogData.length > 0) {
          this.dialogData.map((item) => {
            item.settlementStatusName = this.transferSelect(
              item.settlementStatus,
              this.settlementStatusList
            );
            item.settlementIssueStatusName = this.transferSelect(
              item.settlementIssueStatus,
              this.settlementIssueStatusList
            );
            item.paymentStatusName = this.transferSelect(
              item.paymentStatus,
              this.paymentStatusList
            );
            item.receiveStatusName = this.transferSelect(
              item.receiveStatus,
              this.receiveStatusList
            );
          });
        }
      },
      transferSelect(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      closeDialog() {
        this.$emit('settleDialogClose');
      },
    },
  };
</script>
